/*
 * Style fixes injected into Intercom's Messenger iframe (same-origin, no src), which page CSS cannot reach.
 *
 * Spotlight cart bar: hidden. Intercom draws it white with the dark panel's text and offset from the
 * content edge; the theme's cart drawer shows the cart instead.
 * Targets the data-testid; the intercom-* classes are generated and change per Intercom release.
 */

(() => {
  const STYLE_ID = 'ul-intercom-style';
  const CSS = `
    [data-testid="cart-summary-bar"] {
      display: none !important;
    }
  `;

  function inject(frame) {
    let doc;
    try {
      doc = frame.contentDocument;
    } catch {
      return;
    }
    if (!doc || !doc.head || doc.getElementById(STYLE_ID)) return;
    const style = doc.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    doc.head.appendChild(style);
  }

  function scan() {
    document.querySelectorAll('iframe[name="intercom-messenger-frame"]').forEach((frame) => {
      inject(frame);
      if (!frame.dataset.ulStyled) {
        frame.dataset.ulStyled = 'true';
        frame.addEventListener('load', () => inject(frame));
      }
    });
  }

  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  scan();
})();
